module.exports = __webpack_public_path__ + "21d7f362532ffcf0806d71e72c20723b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-right-26.png
// module id = 3220
// module chunks = 0